/**
 * 文件作用：统一轮询策略配置
 * - 所有异步模型轮询参数从此文件获取，schema 中移除 poll 字段
 */
import { PollPolicy } from '../status/types';

export const DEFAULT_POLL_POLICY: PollPolicy = {
  intervalMs: 10000,
  maxAttempts: 300,
};
